import type {FC} from 'react'
import {useEffect} from 'react'
import {useFormik} from 'formik'
import {InputDefault, ModalDefault, SelectDefault} from '../../ui'
import {initialValueMock} from '../../../mocks'

const ModalFormCycle: FC = () => {
  const formik = useFormik({
    initialValues: initialValueMock.cycle,
    onSubmit: (values) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2))
          formik.resetForm()
          document.getElementById('close-modal')?.click()
          resolve(values)
        }, 1000)
      })
    },
  })

  useEffect(() => {
    document.getElementById('add-cycle')?.addEventListener('hidden.bs.modal', () => {
      formik.resetForm()
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <ModalDefault id='add-cycle' title='Add Cycle' hides={['footer']}>
      <form onSubmit={formik.handleSubmit}>
        <div className='d-flex flex-column align-items-center gap-4'>
          <div className='w-100'>
            <label htmlFor='persona' className='form-label'>
              Cycle
            </label>
            <SelectDefault
              id='cycle'
              name='cycle'
              label='cycle'
              options={[
                {label: '1', value: '1'},
                {label: '2', value: '2'},
                {label: '3', value: '3'},
                {label: '4', value: '4'},
                {label: '5', value: '5'},
              ]}
              value={formik.values.cycle}
              onChange={formik.handleChange}
            />
          </div>
          <div className='w-100'>
            <label htmlFor='name' className='form-label'>
              Name
            </label>
            <InputDefault
              type='text'
              id='name'
              name='name'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
          </div>
          <div className='w-100'>
            <label htmlFor='description' className='form-label'>
              Description
            </label>
            <InputDefault
              type='text'
              id='description'
              name='description'
              value={formik.values.description}
              onChange={formik.handleChange}
            />
          </div>
        </div>
        <div className='d-flex justify-content-end pt-6 gap-4'>
          <button type='button' id='close-modal' className='btn btn-light' data-bs-dismiss='modal'>
            Cancel
          </button>
          <button disabled={formik.isSubmitting} type='submit' className='btn btn-primary'>
            Submit
          </button>
        </div>
      </form>
    </ModalDefault>
  )
}

export default ModalFormCycle
